export default __webpack_public_path__ + "static/media/photo02_pc@2x.5663f8e2.jpg";